import type { ReactNode, MouseEvent } from 'react'
import { useScrollIntoViewIfNeeded } from '@hooks/useScrollIntoViewIfNeeded'
import { FormattedMessage } from 'react-intl'

interface NodeButtonProps {
  active: boolean
  className: string
  onClick: (e: MouseEvent) => void
  containerSelector?: string
  children: ReactNode
}

export function AddOperationButton({
  active,
  onClick
}: {
  active: boolean
  onClick: (e: MouseEvent) => void
}) {
  return (
    <NodeButton
      active={active}
      className={`node-button operation-node-button ${active ? 'selected' : ''}`}
      onClick={onClick}
    >
      <div>
        <div className="icon icon-plus" />
        <span>
          <FormattedMessage id="builder-area.button.add-operation" />
        </span>
      </div>
    </NodeButton>
  )
}

export default function NodeButton({
  active,
  className,
  onClick,
  containerSelector = '#query-builder-area',
  children
}: NodeButtonProps) {
  const ref = useScrollIntoViewIfNeeded<HTMLButtonElement>(active, {
    containerSelector
  })

  return (
    <button ref={ref} className={className} onClick={onClick}>
      {children}
    </button>
  )
}
